import type { BaseToolTipMobileProps } from './interfaces';
import styles from './BaseToolTipMobile.module.scss';
import clsx from 'clsx';

const BaseToolTipMobile = ({ children, isVisible }: BaseToolTipMobileProps) => {
  return (
    <div className={clsx(styles.base, { [styles.show]: isVisible })}>
      {children}
    </div>
  );
};

export default BaseToolTipMobile;
